export type SuccessfulLoginResponse = {
  tokenType: string,
  accessToken: string,
  expiresIn: number,
  refreshToken: string
}

export function isSuccessfulLoginResponse(obj: any): obj is SuccessfulLoginResponse {
  return 'tokenType' in obj
    && 'accessToken' in obj
    && 'expiresIn' in obj
    && 'refreshToken' in obj
}